import Button from '../../Button'

export const TAB_SCROLL_BUTTON_PROPS = {
  Component: Button.Contained,
  isLight: true,
}
